import { Box } from "@mui/material";
import { FC } from "react";
import logo from '../../../assets/img/ufo.png';

interface IssueInfoProps {
    date: string;
}

const IssueInfo: FC<IssueInfoProps> = ({ date = "01-01-2023" }) => (
    <Box
        sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
        }}
    >
        <Box>
            <img
                src={logo}
                alt="Logo"
                style={{
                    width: 120,
                    height: "auto",
                    marginBottom: 20,
                    marginLeft: 20,
                }}
            />
        </Box>
        <table
            style={{
                borderCollapse: "collapse",
                width: 320,
                fontSize: 13,
                marginBottom: 20,
            }}
        >
            <tbody>
                <tr>
                    <td
                        style={{
                            background: "#b8a58abe",
                            border: "1px solid #222",
                            padding: "4px 12px",
                            fontWeight: 500,
                            height: 20,
                        }}
                    >
                        Miejsce wystawienia
                    </td>
                    <td
                        style={{
                            border: "1px solid #222",
                            padding: "4px 12px",
                        }}
                    >
                        Warszawa
                    </td>
                </tr>
                <tr>
                    <td
                        style={{
                            background: "#b8a58abe",
                            border: "1px solid #222",
                            padding: "4px 12px",
                            fontWeight: 500,
                            height: 20,
                        }}
                    >
                        Data wystawienia
                    </td>
                    <td
                        style={{
                            border: "1px solid #222",
                            padding: "4px 12px",
                        }}
                    >
                        {date}
                    </td>
                </tr>
            </tbody>
        </table>
    </Box>
);

export default IssueInfo;